import { useQuery } from 'react-query';
import CheckmateApiClient from '../../../services/apiClient';

export const useGetCaseAuditLog = 'get-quad-case-audit-log';

export const useGetQuadCaseAuditLogs = (caseGuid?: string) => {
    const _apiClient = new CheckmateApiClient();
    return useQuery({
        queryKey: [useGetCaseAuditLog, caseGuid],
        queryFn: async () => {
            const response = await _apiClient.getQuadCaseAuditLogs(caseGuid ?? '');

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve the audit logs for this case.');
            }

            return response.payload;
        },
        enabled: !!caseGuid,
        cacheTime: 0,
        staleTime: 0,
    });
};
